webpackJsonp([78],{

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(818);


/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _enGb = __webpack_require__(564);

var _enGb2 = _interopRequireDefault(_enGb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-gb', _enGb2.default);

/***/ })

},[1618]);


// WEBPACK FOOTER //
// app/datetime.en-gb-b05478e630bcc029afa5.js